export const TIME_LINE_DETAIL="TIME_LINE_DETAIL"
export const TIME_LINE_DETAIL_SUCCESS="TIME_LINE_DETAIL_SUCCESS"
export const TIME_LINE_DETAIL_FAILED="TIME_LINE_DETAIL_FAILED"
export const SEND_REMINDER="SEND_REMINDER"
export const SEND_REMINDER_SUCCESS="SEND_REMINDER_SUCCESS"
export const SEND_REMINDER_FAILED="SEND_REMINDER_FAILED"